import { IString } from '../../../model';
import { ITableColumn, ITableSortValue, TableSortAction } from '../model';
import { log } from './error';
import { deepClone } from './clone';

function sortChildren<T>(
  newData: Array<T>,
  column: ITableColumn<T>,
  type: TableSortAction
) {
  if (type) {
    const dataSource: Array<T> = [];
    for (const item of newData) {
      // 断开引用，防止初始数据被污染
      const data: any = deepClone(item);
      const isTreeNode = Array.isArray(data.children) && !!data.children.length;
      if (isTreeNode) {
        const stack = [data];
        while (stack.length) {
          const node = stack.pop();
          if (Array.isArray(node.children) && node.children.length) {
            // 升序排序
            if (type === TableSortAction.ascending) {
              node.children.sort(column.sorter);
            } else if (type === TableSortAction.descending) {
              // 降序反转
              node.children.reverse();
            }
            stack.push(...node.children);
          }
        }
      }
      dataSource.push(data);
    }
    return dataSource;
  }
  return newData;
}

export function localSortData<T>(
  data: T[],
  value: ITableSortValue | null,
  column: ITableColumn<T>,
  backupData: ReadonlyArray<T>
) {
  const order = value?.order;
  const isDes = order === TableSortAction.descending; // 是否降序
  const isAsc = order === TableSortAction.ascending; // 是否升序
  if (!isDes && !isAsc) {
    return backupData.slice();
  }

  if (column.sorter) {
    const newData: Array<T> = sortChildren<T>(
      data.sort(column.sorter),
      column,
      TableSortAction.ascending
    );
    if (isDes) {
      return sortChildren<T>(
        newData.reverse(),
        column,
        TableSortAction.descending
      );
    }
    return newData;
  }

  const key = value?.key;
  if (!key) {
    log.error(`sort key not found. ${value}`);
    return [];
  }

  return data.sort((a: IString<any>, b: IString<any>) =>
    isDes ? b[key] - a[key] : a[key] - b[key]
  );
}
